/**
 * 模块名称: SN编码
 * @author zhuyan@372163.com
 */
import React, { useState, useEffect, useMemo, useRef } from 'react'
import api from '@/api'
import {
  Table,
  Form,
  Input,
  Select,
  Spin,
  Button,
  Modal,
  message
} from 'antd'
import Auth from '@/components/AuthMiddleware'
import moment from 'moment'
import copy from 'copy-to-clipboard'

const pageIndex = 1
const perPage = 10
let searchParam = {
  page: pageIndex,
  limit: perPage,
}
const { Option } = Select
const FormItem = Form.Item

const SnCode = (props) => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue } = props.form
  const { match, location, history } = props
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(pageIndex)
  const [limit, setPageSize] = useState(perPage)
  const [total, setTotal] = useState(0)
  const [dataSource, setDataSource] = useState([])
  const [viewModalVisible, setViewModalVisible] = useState(false)
  const [viewRecord, setViewRecord] = useState([])

  useEffect(() => {
    document.documentElement.scrollTop = 0
    getList()
  }, [])

  const getList = values => {
    if (values) {
      const { page, limit } = searchParam
      searchParam = { page, limit, ...values }
    }
    let params = { ...searchParam }
    setLoading(true)
    api.getVrSnCodeGenerationList(params).then(data => {
      setPage(searchParam.page)
      setPageSize(searchParam.limit)
      setTotal(data.count)
      setDataSource(data.list)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const onFormSubmit = (e) => {
    e.preventDefault()
    validateFields((err, values) => {
      if (!err) {
        const formattedValues = {
          ...values,
          snQuantity: +values.snQuantity
        }
        setLoading(true)
        api.getVrSnCodeGenerationSave(formattedValues).then((data) => {
          searchParam = {
            page: pageIndex,
            limit: perPage,
          }
          setPageSize(perPage)
          getList()
        }).catch(() => setLoading(false))
      }
    })
  }

  const resetParams = () => {
    setFieldsValue({
      equipmentCode: undefined,
      generationDate: moment().format('YYYYMMDD'),
      // startSerialNumber: '0001',
      snQuantity: undefined
    })
    // searchParam = {
    //   page: pageIndex,
    //   limit: perPage,
    // }
    // setPageSize(perPage)
  }

  const cols = [{
    title: '设备字母缩写',
    dataIndex: 'equipmentCode',
    align: 'center',
  }, {
    title: '日期',
    dataIndex: 'generationDate',
    align: 'center',
  }, {
    title: 'SN编码数量',
    dataIndex: 'snQuantity',
    align: 'center',
  }, {
    title: '已入库二维码数量',
    dataIndex: 'qrCodeQuantity',
    align: 'center',
    render: (text, record) => (
      <a onClick={() => handleJumpToStock(record)}>{text}</a>
    )
  }, {
    title: '操作',
    dataIndex: 'actions',
    align: 'center',
    render: (text, record) => (
      <div style={{ display: 'flex', minWidth: '80px', gap: '8px', justifyContent: 'center' }}>
        <a onClick={() => handleView(record)}>查看</a>
        <a onClick={() => handleDownload(record)}>下载</a>
        <a onClick={() => handleCopySnCodes(record)}>复制</a>
      </div>
    )
  }]

  const onChangeTable = (pagination, filters, sorter) => {
    searchParam.page = pagination.current
    searchParam.limit = pagination.pageSize
    getList()
  }

  // 跳转
  const handleJumpToStock = async (record) => {
    try {
      const res = await api.getSnCodeGenerationRecordList({ generationId: record.id, limit: global.paramsLimit })
      const usedList = (res.list || []).filter(item => item.isUsed === 2)
      const snList = usedList.map(item => item.snCode)

      history.push({
        pathname: '/vr/stock',
        state: snList.length > 0 ? { usedSnCodes: snList } : {}
      })
    } catch (err) {
      console.error(err)
    }
  }

  // 查看
  const handleView = (record) => {
    setViewRecord([])
    api.getSnCodeGenerationRecordList({ generationId: record.id, limit: global.paramsLimit }).then((data) => {
      setViewRecord(data.list)
      setViewModalVisible(true)
    }).catch()
  }

  // 下载
  const handleDownload = async (record) => {
    try {
      const res = await api.getSnCodeGenerationRecordList(
        { generationId: record.id, limit: global.paramsLimit },
        { responseType: 'json' }
      )
      const list = res.list || []
      const content = list.map(item =>
        item.isUsed === 2 ? `${item.snCode}（已使用）` : item.snCode
      ).join('\n')
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${record.equipmentCode}_SN列表.txt`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    } catch (err) {
      console.error(err)
    }
  }

  // 复制
  const handleCopySnCodes = async (record) => {
    try {
      const res = await api.getSnCodeGenerationRecordList({ generationId: record.id, limit: global.paramsLimit })
      const list = res.list || []
      const unusedSnList = list
        .filter(item => item.isUsed === 1)
        .map(item => item.snCode)
      if (unusedSnList.length === 0) {
        message.warning('无未入库的 SN 编码可复制')
        return
      }
      const textToCopy = unusedSnList.join('\n')
      copy(textToCopy)
      message.success(`已复制 ${unusedSnList.length} 条未入库的 SN 编码`)
    } catch (err) {
      console.error(err)
      message.error('复制失败，请稍后重试')
    }
  }

  return (
    <div className="vrdevice-stockSnCode-container">
      <Spin spinning={loading} tip="Loading...">
        <div className='stockSnCode-header'>
          <Form layout='inline' onSubmit={onFormSubmit} >
            <FormItem label='设备字母缩写' style={{ marginBottom: 0 }}>
              {getFieldDecorator('equipmentCode', {
                rules: [{ required: true, message: '请输入设备字母编码' }],
                normalize: value => value && value.toUpperCase(),
              })(<Input placeholder='请输入设备字母缩写' />)}
            </FormItem>
            <FormItem label='日期' style={{ marginBottom: 0 }}>
              {getFieldDecorator('generationDate', {
                initialValue: moment().format('YYYYMMDD'),
                rules: [
                  // { required: true, message: '请输入正确的年月日8位数字' },
                  {
                    validator: (_, value, callback) => {
                      if (!/^\d{8}$/.test(value)) {
                        callback('请输入正确的年月日8位数字')
                      } else if (!moment(value, 'YYYYMMDD', true).isValid()) {
                        callback('请输入有效的年月日')
                      } else {
                        callback()
                      }
                    }
                  },
                ],
              })(<Input style={{ width: '120px' }} />)}
            </FormItem>
            {/* <FormItem label='编码开始序号' style={{ marginBottom: 0 }}>
              {getFieldDecorator('startSerialNumber', {
                initialValue: '0001',
                rules: [
                  {
                    validator: (_, value, callback) => {
                      if (!/^\d{4}$/.test(value)) {
                        callback(`请输入正确的4位序号，不足4位的请在前方补0`)
                      } else {
                        callback()
                      }
                    }
                  },
                ],
              })(<Input style={{ width: '200px' }} />)}
            </FormItem> */}

            <FormItem label='SN编码生成数量' style={{ marginBottom: 0 }}>
              {getFieldDecorator('snQuantity', {
                rules: [
                  { required: true, message: '请输入生成数量' },
                  {
                    validator: (_, value, callback) =>
                      (value < 1 || value > 9999) ? callback('请输入1~9999之间的数值') : callback(),
                  },
                ],
              })(<Input style={{ width: '120px' }} />)}
            </FormItem>

            <FormItem>
              <Button style={{ marginRight: '10px' }} onClick={resetParams}>重置</Button>
              <Button type='primary' htmlType='submit'>生成</Button>
            </FormItem>
          </Form>
        </div>
        <div className='line'></div>
        <div style={{ height: '20px' }}> </div>
        <Table
          size="small"
          columns={cols}
          rowKey={(record, i) => i}
          dataSource={dataSource}
          scroll={{ x: 'max-content' }}
          pagination={{
            defaultCurrent: pageIndex,
            pageSize: limit,
            total: total,
            showSizeChanger: true,
            showQuickJumper: true,
            current: page,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
        ></Table>
      </Spin>
      <Modal
        title="查看"
        visible={viewModalVisible}
        footer={null}
        onCancel={() => setViewModalVisible(false)}
        width={600}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          {(viewRecord || []).map((item, index) => (
            <div key={index}>
              <span style={{ color: item.isUsed === 2 ? 'red' : '#333' }}>
                {item.snCode}
              </span>
              <span style={{ color: '#333' }}>,</span>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  )
}

export default Form.create()(SnCode)
